import * as Yup from 'yup';

export const CategoryValidationSchema = Yup.object().shape({
    name: Yup.string().required("financial.maintenance_cat.add.name_required"),
    description: Yup.string().required("financial.maintenance_cat.add.description_required"),
    //categoryId: Yup.number().required("El estado es requerido"),
})